import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


const ConfirmLayout = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	min-height: 16px;

	${(p: WithThemeProps) => p.theme && `
		color: ${p.theme.palette.dangerPrimary};
	`}
`;

const LabelLayout = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	min-height: 16px;
`;

export {
	ConfirmLayout,
	LabelLayout,
};
